import { Category } from "../Models/GeocodeResponse.js";

export class MapboxCategoryMapping {
  static map = {
    [Category.BUS_STOP]: ["bus station", "bus stop"],
    [Category.FERRY_TERMINAL]: ["pier"],
    [Category.TRAIN_STATION]: ["railway station", "railway platform"],
  };
}
